<template>
    <div class="register-questions-container">
        <div class="progress-bar">
            <span class="done-step" :style="{ width: doneStepWidth }"></span>
            <span class="rest-step" :style="{ width: restStepWidth }"></span>
        </div>
        <h2 class="title">{{ title }}</h2>
        <div class="sub-title" v-if="subTitle">{{ subTitle }}</div>
        <div class="register-questions-list">
            <template
                v-for="question in newQuestionsList"
            >
                <div
                    class="register-questions-item"
                    v-for="item in question.item"
                    :key="item.label + question.key"
                    @click="handClick(item, question.behavior)"
                >
                    <div class="register-questions-label">{{ item.label }}</div>
                </div>
            </template>
        </div>
        <div
            class="previous-btn"
            v-if="showPreviousBtn"
            @click="handlePrevious"
        >
            <i class="iconfont icon-arrow_06_left"></i>
            <span class="back-text">{{ $t('back') }}</span>
        </div>
    </div>
</template>

<script>
export default {
    i18next: {
        ns: 'common'
    },
    data: function() {
        return {
            currentHouseType: '',
            step: 1, // 当前显示的是第几步的问题
        };
    },
    props: {
        questionConfigs: {
            type: Array,
            default: () => {
                return [];
            }
        },
        currentStep: {
            type: [String, Number],
            default: 1
        },
        resultList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        hasPhoneAddOn: {
            type: Boolean,
            default: false
        },
        hasValidPhone: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        currentStep(newVal) {
            if (newVal) {
                this.step = newVal;
            }
        },
    },
    mounted() {
        this.step = this.currentStep;
    },
    computed: {
        newQuestionsList() {
            return [].concat(this.targetStepInfo);
        },
        targetStepInfo() {
            return this.questionConfigs[this.step - 1] || {};
        },
        showPreviousBtn() {
            return this.targetStepInfo.showBackBtn;
        },
        title() {
            return this.targetStepInfo.title;
        },
        subTitle() {
            return this.targetStepInfo.subTitle;
        },
        doneStepWidth() {
            return (((this.step - 1) / this.questionConfigs.length * 100) || 10) + '%';
        },
        restStepWidth({ doneStepWidth }) {
            return (100 - Number(doneStepWidth.replace('%', ''))) + '%';
        }
    },
    methods: {
        handClick(item) {
            this.step++;
            this.$emit('updateResultList', [...this.resultList, item.data]);
            if (item.showHomePage) {
                this.$emit('showHomePage');
                return;
            } else if (item.showScheduleTourAds) {
                this.$emit('showScheduleTourAds');
                return;
            } else if (item.openPhonePopup && this.hasPhoneAddOn && !this.hasValidPhone) {
                this.$emit('showPhonePopup', { from: 'adQuestionsPop' });
                return;
            }
            if (this.step > this.questionConfigs.length) {
                this.$emit('finishedQuestions', {
                    isFinished: true,
                    goFinishedPage: true
                });
                return;
            }
        },
        handlePrevious() { // 注意点击back时，要考虑homePage 和 scheduleTourAds是否需要重置
            this.step--;
            if(this.step <= 3) {
                this.$emit('resetHomeAndSchedule');
            }
            // 删除最后一项，因为点击back时，要回到上一题，所以需要删除最后一项
            this.$emit('updateResultList', this.resultList.slice(0, -1));
        }
    }
};
</script>

<style lang="scss" scope>
@import '@/theme/mixin.scss';
.register-questions-container {
    .progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 5px;
        display: flex;
        .done-step {
            height: 100%;
            background-color: var(--g-btn-background);
        }
        .rest-step {
            height: 100%;
            background-color: rgba(218, 218, 218, 0.5);
        }
    }
    height: 100%;
    h2 {
        flex-shrink: 0;
        font-size: 20px;
        font-weight: 700;
        line-height: 1;
        color: var(--g-primary-color);
        text-align: center;
        margin-bottom: 20px;
        font-family: 'font-Montserrat-700';
    }
    .sub-title {
        font-size: 16px;
        line-height: 1.5;
        color: var(--g-primary-color);
        margin-bottom: 20px;
        font-family: 'font-Montserrat-400';
    }
    .register-questions-list {
        margin-top: 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .register-questions-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border: 1px solid var(--g-btn-background);
            color: var(--g-btn-background);
            background-color: transparent;
            border-radius: 0;
            cursor: pointer;
            padding: 10px;
            box-sizing: border-box;
            .register-questions-label {
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                font-family: 'font-Montserrat-500';
            }
            &:hover {
                background-color: rgba(0, 0, 0, 0.1);
            }
        }
    }
    .previous-btn {
        position: absolute;
        z-index: 10;
        bottom: 30px;
        left: 0;
        right: 0;
        width: 200px;
        margin: 0 auto;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        color: #a8a8a8;
        cursor: pointer;
        .iconfont {
            font-size: 14px;
            &::before {
                color: #a8a8a8;
            }
        }
        .back-text {
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
